import { useTranslation } from "react-i18next";
import Select from "../Select";
import Search from "../Search";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

const TEMPLATE_TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: "nudge", label: "Nudge" },
  { value: "evaluation", label: "Evaluation" },
  { value: "summarization", label: "Summarization" },
  { value: "custom", label: "Custom" },
];

export default function PromptTemplateFilters({
  templateType,
  onTemplateTypeChange,
  isActive,
  onIsActiveChange,
  searchKey,
  onSearchChange,
}) {
  const { t } = useTranslation();

  return (
    <div style={{ display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
      <Select
        list={TEMPLATE_TYPE_OPTIONS}
        value={templateType || ""}
        onChange={e => onTemplateTypeChange(e.target.value)}
        placeholder="All Types"
        style={{ minWidth: 150 }}
      />
      <FormControlLabel
        control={
          <Switch
            checked={isActive === 1}
            onChange={e => onIsActiveChange(e.target.checked ? 1 : 0)}
            color="primary"
          />
        }
        label={isActive === 1 ? "Active" : "Inactive"}
      />
      <Search
        handleSearch={val => onSearchChange(val)}
        placeholder={t("promptTemplate.searchPlaceholder") || "Search by name..."}
      />
    </div>
  );
}